import React from 'react';

export default () => <h1>Escriba una direccion correcta</h1>